import React, {Component, ReactElement} from "react";
import {Brand} from "../../../service/domain/brands";
import {Market} from "../../../service/domain/markets";

export interface OrganizationDetailsViewProps {
  id: string;
  name: string | null;
  number: string | null;
  brands: Brand[];
  markets: Market[];
}

/**
 * A read-only view of the organization details.
 */
// eslint-disable-next-line max-len
export default class OrganizationDetailsView extends Component<OrganizationDetailsViewProps> {
  render(): ReactElement {
    const {id, brands, markets, name, number} = this.props;

    return (
      <div>
        <dl>
          <dt>Id</dt>
          <dd>{id}</dd>
          <dt>Name</dt>
          <dd>{name}</dd>
          <dt>Number</dt>
          <dd>{number}</dd>
          <dt>Brands</dt>
          <dd>
            <ol>
              {brands.map((item) => {
                return <li key={item.id}>{item.name}</li>;
              })}
            </ol>
          </dd>
          <dt>Markets</dt>
          <dd>
            <ol>
              {markets.map((item) => {
                return <li key={item.id}>{item.name}</li>;
              })}
            </ol>
          </dd>
        </dl>
      </div>
    );
  }
}
